import { render, staticRenderFns } from "./ReportBonus.vue?vue&type=template&id=756c10f2"
import script from "./ReportBonus.vue?vue&type=script&lang=js"
export * from "./ReportBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports